export const APPROVAL_STATUSES = {
  GRANTED: 'Granted',
  DENIED: 'Denied',
  PENDING: 'Pending',
};

// TODO verify enum values
export const APPROVAL_TYPES = {
  budget: 'OpportunityBudget',
  creatives: 'CreativeProducts',
  opportunityCampaignType: 'OpportunityCampaignType',
};

export const TeamAssociationLabel = object => object.name;
export const TeamAssociationFilterFields = ['name'];

export const approvalConfirmationMessages = {
  [APPROVAL_TYPES.budget]:
    'Keep in mind that once you request High-Value Opportunity approval, respective ZMS Management and (S)PC Team Leads will be notified via email. Do you want to confirm?',
  [APPROVAL_TYPES.creatives]:
    'Once requested, Creative AMs will be notified via email. Do you want to confirm?',
  [APPROVAL_TYPES.opportunityCampaignType]:
    'Once requested Management will be notified via email for a proof check. Do you confirm?',
};
